import React, { Component } from "react";
import { Popover, Form, Button, Icon, Table, Modal, Input, Select, message } from "antd";
import { departmentList, getAffiliatedHospitelList } from '@/request/api'
import { requestErrorLog } from '@/common/util'

const { TextArea } = Input;
const { Option } = Select;
const { confirm } = Modal;

class SettingDepartment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableList: [],
      PageNo: 1,
      PageSize: 10,
      RowCount: 0,
      deptCode: '',
      deptName: '',
      hospitalData: [],
      departmentColumns: [
        {
          title: "所属医院",
          dataIndex: "HOSPITAL_UID",
          key: "HOSPITAL_UID",
          width: 170,
          render: (text) => {
            return this.state.hospitalData.map((item, index) => {
              const a = item.HOSPITAL_UID === text ? item.HOSPITAL_NAME : null
              return <Popover overlayStyle={{ width: '200px' }} key={index} content={<span style={{ color: '#333' }}>{a}</span>}><span>{a}</span></Popover>
            });
          }
        },
        {
          title: "科室编码",
          dataIndex: "DEPT_CODE",
          key: "DEPT_CODE",
          width: 300,
          render: (text) => {
            return (
              <Popover
                overlayStyle={{ width: "350px" }}
                content={<span style={{ color: "#333" }}>{text}</span>}
              >
                <span>{text}</span>
              </Popover>
            );
          },
        },
        {
          title: "科室名称",
          dataIndex: "DEPT_NAME",
          key: "DEPT_NAME",
          width: 170,
          render: (text) => {
            return (
              <Popover
                overlayStyle={{ width: "200px" }}
                content={<span style={{ color: "#333" }}>{text}</span>}
              >
                <span>{text}</span>
              </Popover>
            );
          },
        },
        {
          title: "科室说明",
          dataIndex: "DEPT_REMARK",
          key: "DEPT_REMARK",
          render: (text) => {
            return (
              <Popover
                overlayStyle={{ width: "200px" }}
                content={<span style={{ color: "#333" }}>{text}</span>}
              >
                <span>{text}</span>
              </Popover>
            );
          },
        },
      ],
    }
  }

  componentDidMount() {
    this.getHospitalList()
    this.departmentList()
  }

  getHospitalList = () => { // 获取医院列表
    getAffiliatedHospitelList().then((res) => {
      if (res && res.Status === 1) {
        const data = res.Result
        this.setState({
          hospitalData: data,
        })
      } else {
        requestErrorLog('', '权限管理-科室管理-获取医院列表报错', 0, true)
      }
    })
  }

  departmentList = () => { // 科室列表 
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    let params = {
      Type: "SELECT",
      HOSPITAL_UID: userInfo.HOSPITAL_UID,
      DEPT_CODE: this.state.deptCode,
      DEPT_NAME: this.state.deptName,
      PageNo: this.state.PageNo,
      PageSize: this.state.PageSize,
      USER_UID: userInfo.USER_UID
    }
    departmentList(params).then((res) => {
      if (res && res.Status === 1) {
        const dataList = res.Result.dataInfo
        let RowCount = res.Result.pageInfo.RowCount
        this.setState({
          tableList: dataList,
          RowCount
        })
      } else {
        requestErrorLog('', '权限管理-科室管理-获取科室列表报错', 0, true)
      }
    })
  }


  handleDepartmentAdd = () => {// 新增
    this.props.form.resetFields();    //清空form中每条数据
    this.setState({
      isModalVisible: true,
      modalTitle: 'ADD',
      rowData: {
        DEPT_NAME: "",
        DEPT_REMARK: ""
      }
    })
  }

  handleDepartmentEdit = () => { // 修改
    const { rowData } = this.state
    this.props.form.resetFields();    //清空form中每条数据
    if (rowData && rowData.HOSPITAL_UID) {
      this.setState({
        isModalVisible: true,
        modalTitle: 'EDIT',
      })
    } else {
      message.warning('请先选择要操作的数据');
    }
  }

  handleDepartmentDelete = () => { // 删除
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    const { rowData } = this.state
    if (!rowData) {
      message.warning('请先选择要操作的数据');
    } else {
      confirm({
        title: '删除操作',
        content: '科室如果被删除，该科室下的用户都会被删除，是否确认删除？',
        onOk: () => {
          let params = {
            Type: "DELETE",
            DEPT_UID: rowData.DEPT_UID,
            USER_UID: userInfo.USER_UID
          }
          departmentList(params).then((res) => {
            if (res && res.Status === 1) {
              if (res.Result === -1) {
                message.error("不存在该数据！")
                return;
              }
              if (res.Result === -2) {
                message.error("编辑人与添加人需一致！")
                return;
              }
              this.departmentList()
              message.success("删除成功！")
              this.setState({ rowData: '' })
            } else {
              requestErrorLog('', '权限管理-科室管理-删除科室报错', 0, true)
              message.error("删除失败！")
            }
          })
        },
      });
    }
  }

  handleDeptSubmit = () => {
    const { rowData, modalTitle } = this.state
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
        let Param = {
          Type: modalTitle,
          HOSPITAL_CODE: modalTitle === 'ADD' ? userInfo.HOSPITAL_CODE : '',
        }
        let RequestModel = {};
        RequestModel = {
          HOSPITAL_UID: values.HOSPITAL_UID, // 所属医院uid
          DEPT_UID: modalTitle === 'EDIT' ? rowData.DEPT_UID : '',     // 科室uid
          DEPT_CODE: modalTitle === 'EDIT' ? rowData.DEPT_CODE : '',   // 科室编码
          DEPT_NAME: values.DEPT_NAME,    // 科室名称
          DEPT_REMARK: values.DEPT_REMARK,  // 科室描述
          DEPT_ORDER: null, // 排序
          DELETE_FLAG: 0    // 删除标志
        }
        if (modalTitle === 'ADD') {
          RequestModel.CREATE_UID = userInfo.USER_UID;
        }
        if (modalTitle === 'EDIT') {
          RequestModel.EDIT_UID = userInfo.USER_UID;
        }
        console.log(RequestModel, 'RequestModel')
        departmentList(Param, RequestModel).then((res) => {
          if (res && res.Status === 1) {
            if (res.Result === -2) {
              message.error("科室名称不能相同！")
              return;
            }
            if (res.Result === -1) {
              message.error("不存在该数据！")
              return;
            }
            if (res.Result === -3) {
              message.error("编辑人与添加人需一致！")
              return;
            }
            this.setState({ isModalVisible: false, rowData: '' })
            this.departmentList()
            modalTitle === 'ADD' ? message.success("新建成功") : message.success("修改成功！")
          } else {
            requestErrorLog('', '权限管理-科室管理-' + modalTitle === 'ADD' ? '新建科室报错' : '编辑科室报错', 0, true)
            modalTitle === 'ADD' ? message.error("新建失败") : message.error("修改失败！")
          }
        });
      }
    })
  }

  onClickRow = (record) => {
    return {
      onClick: () => {
        this.setState({
          rowData: record
        });
      },
    };
  }

  setRowClassName = (record) => {
    return record === this.state.rowData ? 'clickRowStyl' : '';
  }

  handleCancel = () => {
    this.setState({
      isModalVisible: false,
    })
  }

  //筛选
  handleDeptCode = e => {
    this.setState({
      deptCode: e.target.value,
    })
  }
  handleDeptName = e => {
    this.setState({
      deptName: e.target.value
    })
  }

  handleDtpeList = () => {
    this.setState({
      PageNo: 1,
      PageSize: 10
    }, () => {
      this.departmentList()
    })
  }
  changeFocus = e => {
    if (e.keyCode === 13) {
      this.handleDtpeList();
    }
  }
  changePageFn = (PageNo) => {
    this.setState({
      PageNo
    }, () => {
      this.departmentList()
    })
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { isModalVisible, modalTitle, departmentColumns, tableList, rowData } = this.state;
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    const roleList = JSON.parse(localStorage.getItem('roleList')) || {}
    return (
      <div>
        <div className="btnStyle" style={{ marginBottom: "10px" }}>
          <Button onClick={this.handleDepartmentAdd}>
            <Icon type="plus-circle" />
            添加
          </Button>
          <Button onClick={this.handleDepartmentEdit}>
            <Icon type="minus-circle" />
            修改
          </Button>
          <Button onClick={this.handleDepartmentDelete}>
            <Icon type="close-circle" />
            删除
          </Button>
        </div>
        <Form layout="inline" className="searchBox">
          <Form.Item label="科室编码">
            <Input allowClear value={this.state.deptCode} onChange={this.handleDeptCode} onKeyUp={this.changeFocus} />
          </Form.Item>
          <Form.Item label="科室名称">
            <Input allowClear value={this.state.deptName} onChange={this.handleDeptName} onKeyUp={this.changeFocus} />
          </Form.Item>
          <Button onClick={this.handleDtpeList}>查询</Button>
        </Form>
        <Table
          columns={departmentColumns}
          dataSource={tableList}
          rowKey={(record) => record.DEPT_CODE}
          pagination={{
            total: this.state.RowCount,
            current: this.state.PageNo,
            onChange: this.changePageFn
          }}
          onRow={this.onClickRow}
          rowClassName={this.setRowClassName}
        />
        <Modal
          title={
            <div className="patient_title">
              <img alt="" src={require("@/assets/image/ecg.png").default} className="addIcon" />
              <span>{modalTitle === "ADD" ? "添加科室" : "编辑科室"}</span>
            </div>
          }
          visible={isModalVisible}
          maskClosable={false}
          onOk={this.handleDeptSubmit}
          onCancel={this.handleCancel}
        >
          <Form layout="inline">
            <Form.Item label="所属医院" className="settingHospitalRequire">
              {getFieldDecorator('HOSPITAL_UID', { initialValue: modalTitle === 'EDIT' ? rowData.HOSPITAL_UID : '', rules: [{ required: true, message: '请选择所属医院' }] })(
                userInfo.IS_ADMINISTRATOR === "1" || roleList.indexOf('二级管理员') > -1 ?
                  <Select style={{ width: '192px' }} showSearch optionFilterProp="children" disabled={modalTitle === "EDIT" ? true : false}>
                    {
                      this.state.hospitalData.map((item) => (
                        <Option key={item.HOSPITAL_UID} value={item.HOSPITAL_UID}>{item.HOSPITAL_NAME}</Option>
                      ))
                    }
                  </Select>
                  : null
                // <Select style={{ width: '192px' }} disabled>
                //   {
                //     this.state.hospitalData.map((item) => (
                //       <Option key={item.HOSPITAL_UID} value={item.HOSPITAL_UID}>{item.HOSPITAL_NAME}</Option>
                //     ))
                //   }
                // </Select>
              )}
            </Form.Item>
            <Form.Item label="科室名称" className="settingHospitalRequire">
              {getFieldDecorator('DEPT_NAME', { initialValue: rowData && rowData.DEPT_NAME ? rowData.DEPT_NAME : '', rules: [{ required: true, message: '请输入科室名称' }] })(<Input allowClear={true} />)}
            </Form.Item>
            <Form.Item label="科室说明" className="settingHospitalAddr">
              {getFieldDecorator('DEPT_REMARK', { initialValue: rowData && rowData.DEPT_REMARK ? rowData.DEPT_REMARK : '' })(<TextArea rows={4} style={{ width: '400px' }} />)}
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default (Form.create({})(SettingDepartment));
